import React from 'react'
import { observer } from "mobx-react";
import { onSnapshot } from "mobx-state-tree";
import { Col, Row } from "antd";

import { FSelect, Option } from "../common/form";
import { Children } from "../models/Book";

const idToTemplate = {
  "": "",
  "0": 1,
  "1": 2,
  "2": 3,
  "00": 4,
  "10": 5,
  "20": 6,
  "11": 7,
  "21": 8,
  "22": 9,
  "000": 10,
  "100": 11,
  "200": 12,
  "110": 13,
  "210": 14,
  "220": 15,
  "111": 16,
  "211": 17,
  "221": 18,
  "222": 19
};

const templateToId = {
  "": "",
  1: "0",
  2: "1",
  3: "2",
  4: "00",
  5: "10",
  6: "20",
  7: "11",
  8: "21",
  9: "22",
  10: "000",
  11: "100",
  12: "200",
  13: "110",
  14: "210",
  15: "220",
  16: "111",
  17: "211",
  18: "221",
  19: "222"
};


const ChildTemplate = observer(({ child, label }) => (
  <Row type="flex" justify="space-between">
    <Col span={11}>
      <div className="label">{label}</div>
      <FSelect
        defaultValue={child.type}
        onChange={v => child.changeType(v)}
        size="large"
      >
        <Option value={0}>2歳未満</Option>
        <Option value={1}>2歳以上</Option>
      </FSelect>
    </Col>
    {child.type === 1 ?
      <Col span={11}>
        <div className="label">性別</div>
        <FSelect
          defaultValue={child.gender}
          onChange={v => child.changeGender(v)}
          size="large"
        >
          <Option value={0}>男の子</Option>
          <Option value={1}>女の子</Option>
        </FSelect>
      </Col> : null
    }
  </Row>
));

class ChildrenTemplaceRender extends React.Component {
  constructor(props) {
    super(props);
    this.children = Children.create({});
    onSnapshot(this.children, this.onChange);
  }

  componentWillMount() {
    if (this.props.book.childrenTemplate) {
      let ids = templateToId[this.props.book.childrenTemplate].split('');
      ids.forEach((v, k) => this.children[`child${k + 1}`].setUpFromId(parseInt(v)));
    }
  }

  componentWillReceiveProps() {
    this.onChange();
  }

  onChange = () => {
    this.props.book.changeChildrenTemplate(idToTemplate[this.children.id(this.props.book.children)]);
  }

  render() {
    const { children } = this.props.book;
    let ret = [];
    for (let i = 0; i < children; i++) {
      ret.push(
        <ChildTemplate
          child={this.children[`child${i + 1}`]}
          key={i}
          label={children === 1 ? 'お子様の年齢' : `${i + 1}人目のお子様の年齢`}
        />
      );
    }
    return ret;
  }
}

export default observer(ChildrenTemplaceRender);



// WEBPACK FOOTER //
// ./src/components/ChildrenTemplateRender.js